import { useState, useEffect, useMemo } from 'react';
import { useGetTopClickedSimulationsQuery } from '../../../store/services/report.service';

export default function useSimulationData(tenancyId) {
    const [dateRange, setDateRange] = useState('6months');
    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');

    const dateParams = useMemo(() => {
        const now = new Date();
        let startDate, endDate = now;

        switch (dateRange) {
            case '6months':
            default:
                startDate = new Date(now);
                startDate.setMonth(startDate.getMonth() - 6);
                break;
            case '12months':
                startDate = new Date(now);
                startDate.setMonth(startDate.getMonth() - 12);
                break;
            case 'custom':
                if (customStartDate && customEndDate) {
                    startDate = new Date(customStartDate);
                    endDate = new Date(customEndDate);
                } else {
                    startDate = new Date(now);
                    startDate.setMonth(startDate.getMonth() - 6);
                }
                break;
        }

        return {
            startDate: startDate.toISOString().split('T')[0] + ' 00:00:00',
            endDate: endDate.toISOString().split('T')[0] + ' 23:59:59'
        };
    }, [dateRange, customStartDate, customEndDate]);

    const [simulationData, setSimulationData] = useState([]);

    const {
        data: apiSimulationData,
        isLoading: simulationDataLoading,
        error
    } = useGetTopClickedSimulationsQuery({
        tenancyId,
        ...dateParams
    }, { skip: !tenancyId });

    useEffect(() => {
        if (apiSimulationData && !simulationDataLoading) {
            // API returns pre-aggregated top 5: [{ SimulationId, TotalSent, Clicks }]
            const processed = apiSimulationData.map(item => ({
                SimulationId: item.SimulationId,
                SimulationName: item.SimulationId,
                Clicks: item.Clicks,
                TotalSent: item.TotalSent
            }));
            setSimulationData(processed);
        }
    }, [apiSimulationData, simulationDataLoading]);

    return {
        simulationData,
        simulationDataLoading,
        dateRange,
        setDateRange,
        customStartDate,
        setCustomStartDate,
        customEndDate,
        setCustomEndDate
    };
}
